export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-indexlist/index.js